module.exports = __webpack_public_path__ + "img/imprint-treatments.073b52dc.png";